import { useGetCurrenciesQuery } from "api/TenantSlug/Currency/hooks.ts";

export const useCurrencySelectOptions = () => {
    const { data, isLoading, error } = useGetCurrenciesQuery();
    const { currencies = [] } = data || {};

    const options = [...currencies]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((currency) => ({
            label: `${currency.name} (${currency.currency_code})`,
            value: currency.id,
        }));

    return {
        options,
        loading: isLoading,
        error: error ? String(error) : null,
    };
};
